import { getApi, http, adminGet, adminDelete, initAdmin } from './useAdminCore';
function getCacheStats(onSuccess = null) {
    adminGet("/Cache/Stats", onSuccess);
}
function getCacheLog(onSuccess = null) {
    adminGet("/Cache/Log", onSuccess);
}
function getQueueCount(onSuccess = null) {
    adminGet("/Cache/RefreshQueue/Count", onSuccess);
}
function getCachedUrl(url, onSuccess = null) {
    adminGet("/Cached/" + url, onSuccess);
}
function processQueue(onSuccess = null) {
    const api = initAdmin();
    http().post(getApi() + "/Cache/RefreshQueue/ProcessRequests")
        .then((result) => {
        if (onSuccess)
            onSuccess(result.data);
    })
        .catch((result) => {
        if (result.response && result.response.status == 401) {
            api.refreshLogin(() => {
                processQueue(onSuccess);
            });
        }
    });
}
function flushUrl(url, onSuccess = null) {
    const api = initAdmin();
    http().put(getApi() + "/Cached/" + url)
        .then((result) => {
        if (onSuccess)
            onSuccess(result.data);
    })
        .catch((result) => {
        if (result.response && result.response.status == 401) {
            api.refreshLogin(() => {
                flushUrl(url, onSuccess);
            });
        }
    });
}
function clearCache(onSuccess = null) {
    adminDelete("/Cache", onSuccess);
}
function clearCacheStats(onSuccess = null) {
    adminDelete("/Cache/Stats", onSuccess);
}
function deleteUrl(url, onSuccess = null) {
    adminDelete("/Cached/" + url, onSuccess);
}
export { getCacheStats, getCacheLog, getQueueCount, getCachedUrl, processQueue, flushUrl, clearCache, clearCacheStats, deleteUrl, };
